import React from 'react';
import '../styles/index.css';
import imgPlaceholder from './../../../assets/images/placeholder/customer-image-placeholder.png';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { useNavigate } from 'react-router-dom';
import { Alert, Image } from 'react-bootstrap';

function DataTable({ columns, data }) {

  const navigate = useNavigate();

  return (
    <div className='datatable border rounded h-auto'>
      <table className='table mb-0'>
        <thead className='table-head'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 ? 'ps-4 bg-table-head' : index === columns.length - 1 ? 'pe-4 text-start bg-table-head' : 'bg-table-head'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((tb_items, index) => {
                  return (
                    <tr key={index} className='border-top'>
                      <td className='ps-4 align-middle'>{index + 1}</td>
                      <td
                        className="align-middle cursor-pointer"
                        onClick={() => navigate('details', { state: { data: data, items: tb_items } })}
                      >
                        <div className='d-flex align-items-center text-primary'>
                          <span>{tb_items.partyName}</span>
                        </div>
                      </td>
                      <td className="align-middle">{tb_items.fatherHusband}</td>
                      <td className='align-middle'>
                        <div className='d-flex align-items-center justify-content-center'>
                          {
                            tb_items.partyType && tb_items.partyType === "Customer" ?
                              <Alert variant="success" className='p-0 m-0 small text-success fw-normal rounded px-2'>
                                <small>{tb_items.partyType}</small>
                              </Alert>
                              :
                              <Alert variant="danger" className='p-0 m-0 small text-success fw-normal rounded px-2'>
                                <small>{tb_items.partyType}</small>
                              </Alert>
                          }
                        </div>
                      </td>
                      <td className="align-middle">{tb_items.aadharNumber}</td>
                      <td className="align-middle">+91 {tb_items.phoneNumber}</td>
                      <td className="align-middle">{tb_items.city}</td>
                      <td className="align-middle text-start">{tb_items.state}</td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={8}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div >
  );
}

export default DataTable;
